import { useContent } from '@/hooks/useContent';
import { Link } from 'react-router-dom';

export default function FinalCTA() {
  const { t } = useContent('home');
  const { t: tc } = useContent('common');
  const { t: imgT } = useContent('images');

  return (
    <section className="relative py-24 overflow-hidden mb-16">
      <div className="absolute inset-0">
        <img
          alt="Modern energy efficient home exterior at golden hour"
          className="w-full h-full object-cover object-center"
          src={imgT('final_cta')}
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/50 to-black/25 z-[2]"></div>
        <div className="absolute inset-0 bg-black/60"></div>
      </div>
      <div className="relative z-10 max-w-3xl mx-auto px-4 md:px-6 text-center">
        <span className="text-primary-500 text-sm font-semibold uppercase tracking-widest">{t('finalcta_badge')}</span>
        <h2 className="text-4xl md:text-5xl font-extrabold text-white mt-3 leading-tight">{t('finalcta_title')}</h2>
        <p className="text-white/70 mt-5 text-lg leading-relaxed">
          {t('finalcta_desc')}
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center mt-8">
          <Link
            to="/contact"
            className="whitespace-nowrap bg-primary-500 hover:bg-primary-600 text-white font-bold px-10 py-4 rounded-full text-base transition-colors cursor-pointer text-center"
          >
            {tc('common_request_quote')}
          </Link>
          <a
            href="tel:+15747219810"
            className="whitespace-nowrap bg-primary-500 hover:bg-primary-600 text-white font-bold px-10 py-4 rounded-full text-base transition-colors cursor-pointer flex items-center justify-center gap-2 text-center"
          >
            <i className="ri-phone-line w-5 h-5 flex items-center justify-center"></i>
            (574) 721-9810
          </a>
        </div>
      </div>
    </section>
  );
}